import { useThree } from "@react-three/fiber";
import { ClampToEdgeWrapping, Vector2, Color } from "three";
import {
  ColorBackgroundProps,
  NvsBackgroundProps,
  AssetBackgroundProps,
} from "./types";
import { getBackgroundComponent } from "./utils";
import { useEffect } from "react";
import { useTexture } from "@react-three/drei";

export const ColorBackground: React.FC<ColorBackgroundProps> = (props) => {
  const scene = useThree((props) => props.scene);

  useEffect(() => {
    scene.background = new Color(props.hexColor);
  }, [scene, props.hexColor]);
  return <></>;
};

export const StaticBackground: React.FC<AssetBackgroundProps> = ({ asset }) => {
  const assetUrl = asset.url;
  const texture = useTexture(assetUrl);
  texture.colorSpace = "srgb";
  const size = useThree((props) => props.size);
  const scene = useThree((props) => props.scene);

  // Assign the texture to the background
  useEffect(() => {
    scene.background = texture;
  }, [scene, texture]);

  useEffect(() => {
    const { width, height } = texture.image as HTMLImageElement;
    const canvasAspect = size.width / size.height;
    const textureAspect = width / height;
    const relAspect = canvasAspect / textureAspect;
    const revAspect = textureAspect / canvasAspect;

    let x1, x2, y1, y2;
    if (canvasAspect < textureAspect) {
      x2 = relAspect;
      x1 = (1 - x2) / 2;
      y1 = 0;
      y2 = 1;
    } else if (canvasAspect >= textureAspect) {
      y2 = revAspect;
      y1 = (1 - y2) / 2;
      x1 = 0;
      x2 = 1;
    }

    texture.offset = new Vector2(x1, y1);
    texture.repeat = new Vector2(x2, y2);
    texture.wrapT = ClampToEdgeWrapping;
  }, [size.width, size.height, texture]);
  return <></>;
};

export const NvsBackground: React.FC<NvsBackgroundProps> = ({
  backgroundType,
  ...props
}) => {
  const { BackgroundComponent } = getBackgroundComponent(backgroundType);
  return (
    // @ts-expect-error: Unreachable code error
    <>{BackgroundComponent ? <BackgroundComponent {...props} /> : <></>}</>
  );
};
